<template>
  <div class="pwt-custom-overlay">
    <v-card
      v-if="checkingToken"
      class="px-4 pb-3 rounded-0 d-flex flex-column align-items-start justify-start"
      light
      :max-width="mobile ? '' : '800px'"
      :min-width="mobile ? '' : '350px'"
      :min-height="mobile ? '' : '100px'"
      :width="mobile ? '100vw' : '40%'"
      height="100vh"
    >
      <v-card-text v-if="mobile" class="d-flex flex-column align-items-center justify-center">
        <span style="width: 100%" class="text-h5 text-center"> Checking authentication </span>
        <div style="width: 100%" class="d-flex justify-center">
          <LoadingCard />
        </div>
      </v-card-text>
      <v-card-text
        style="height: 100%; min-height: 100px; position: relative"
        class="d-flex justify-center align-center px-8 pt-5"
        v-else
      >
        <v-progress-circular indeterminate color="primary" class="mr-2" />
        <span class="text-h5">Checking authentication</span>
        <PulseLoader />
      </v-card-text>
    </v-card>
  </div>
</template>
<script lang="ts" setup>
import LoadingCard from '@/components/ui-elements/loaders/LoadingCard.vue'
import PulseLoader from '@/components/ui-elements/loaders/PulseLoader.vue'
import type { State } from '@/store/store_types'
import { computed } from 'vue'
import { useDisplay } from 'vuetify'
import { useStore } from 'vuex'

const { mobile } = useDisplay()
const store = useStore<State>()
const checkingToken = computed(() => store.state.checkingToken)
</script>
<style scoped>
.pwt-custom-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1400;
  display: flex;
  backdrop-filter: blur(2px);
}
</style>
